import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme, useMixin } from '@clds/component-theme';
import { ArrowDropDown, ArrowDropUp } from '@clds/icon';
import { numberFieldTheme } from '../theme';

const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 ${globalTheme.spacing.xs};
`;

const TrailingContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  pointer-events: none;
  background: ${numberFieldTheme.buttons.background};
`;

export interface IconAsButtonProps {
  buttonPaddingSize: string;
}

const iconAsButtonCommon = css`
  box-sizing: content-box;
  padding: 0 ${numberFieldTheme.buttons.padding};
  &:focus {
    outline: none;
  }
`;

export const ArrowUpButton = styled(ArrowDropUp).attrs({ tabIndex: 0 })<IconAsButtonProps>`
  ${iconAsButtonCommon}
  ${({ buttonPaddingSize }) => `padding-top: ${buttonPaddingSize};`}
`;
export const ArrowDownButton = styled(ArrowDropDown).attrs({ tabIndex: 0 })<IconAsButtonProps>`
  ${iconAsButtonCommon}
  ${({ buttonPaddingSize }) => `padding-bottom: ${buttonPaddingSize};`}
`;

export interface NumericDecoratorProps {
  isDisabled?: boolean;
}

const NumericDecorator: FC<NumericDecoratorProps> = ({ isDisabled = false }) => {
  const buttonPaddingSize = useMixin(numberFieldTheme.buttons.padding);

  return (
    <>
      <TrailingContainer>
        <ButtonsContainer>
          <ArrowUpButton
            size="xs"
            color={isDisabled ? 'secondaryAlt' : 'contrastLow'}
            aria-disabled={isDisabled ? 'true' : 'false'}
            buttonPaddingSize={buttonPaddingSize}
            data-direction={DIRECTION.UP}
            data-test-specifier="arrow-up"
          />
          <ArrowDownButton
            size="xs"
            color={isDisabled ? 'secondaryAlt' : 'contrastLow'}
            aria-disabled={isDisabled ? 'true' : 'false'}
            buttonPaddingSize={buttonPaddingSize}
            data-direction={DIRECTION.DOWN}
            data-test-specifier="arrow-down"
          />
        </ButtonsContainer>
      </TrailingContainer>
    </>
  );
};
export default NumericDecorator;
